import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(VPagination, {
    attrs: {
      length: _setup.pagesQuantity,
      "total-visible": _setup.totalVisible,
      color: _vm.color,
      circle: "",
    },
    on: { input: _setup.onPageChanged },
    model: {
      value: _setup.page,
      callback: function ($$v) {
        _setup.page = $$v
      },
      expression: "page",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }